(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8552],{

/***/ 326:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(4836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(4938));
var _jsxRuntime = __webpack_require__(5893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), 'Menu');

/***/ }),

/***/ 6565:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(276);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AppWrapperContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6886);
/* harmony import */ var _AppNavBar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7486);



function AppWrapperContainer(param) {
    let { children , nav , navBgColor  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        sx: {
            paddingTop: {
                xs: "55px",
                md: "72px"
            }
        },
        children: [
            nav ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppNavBar__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                navBgColor: navBgColor
            }) : null,
            children
        ]
    });
}


/***/ }),

/***/ 2448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Seo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


function toRobotsContent(robots) {
    if (!robots) return undefined;
    var _index;
    const index = (_index = robots.index) !== null && _index !== void 0 ? _index : true;
    var _follow;
    const follow = (_follow = robots.follow) !== null && _follow !== void 0 ? _follow : true;
    return "".concat(index ? "index" : "noindex", ", ").concat(follow ? "follow" : "nofollow");
}
function Seo(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    const description = (ref = props.description) === null || ref === void 0 ? void 0 : ref.trim();
    const canonicalUrl = (ref1 = props.canonicalUrl) === null || ref1 === void 0 ? void 0 : ref1.trim();
    var ref13;
    const ogTitle = (ref13 = (ref2 = props.openGraph) === null || ref2 === void 0 ? void 0 : ref2.title) !== null && ref13 !== void 0 ? ref13 : props.title;
    var ref14;
    const ogDescription = (ref14 = (ref3 = props.openGraph) === null || ref3 === void 0 ? void 0 : ref3.description) !== null && ref14 !== void 0 ? ref14 : description;
    var ref15;
    const ogType = (ref15 = (ref4 = props.openGraph) === null || ref4 === void 0 ? void 0 : ref4.type) !== null && ref15 !== void 0 ? ref15 : "website";
    var ref16;
    const ogUrl = (ref16 = (ref5 = props.openGraph) === null || ref5 === void 0 ? void 0 : ref5.url) !== null && ref16 !== void 0 ? ref16 : canonicalUrl;
    var ref17;
    const twCard = (ref17 = (ref6 = props.twitter) === null || ref6 === void 0 ? void 0 : ref6.card) !== null && ref17 !== void 0 ? ref17 : "summary_large_image";
    var ref18;
    const twTitle = (ref18 = (ref7 = props.twitter) === null || ref7 === void 0 ? void 0 : ref7.title) !== null && ref18 !== void 0 ? ref18 : props.title;
    var ref19;
    const twDescription = (ref19 = (ref8 = props.twitter) === null || ref8 === void 0 ? void 0 : ref8.description) !== null && ref19 !== void 0 ? ref19 : description;
    var ref20;
    const twUrl = (ref20 = (ref9 = props.twitter) === null || ref9 === void 0 ? void 0 : ref9.url) !== null && ref20 !== void 0 ? ref20 : canonicalUrl;
    const robotsContent = toRobotsContent(props.robots);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: props.title
            }, "title"),
            description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }, "description") : null,
            props.keywords ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: props.keywords
            }, "keywords") : null,
            canonicalUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }, "canonical") : null,
            robotsContent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: robotsContent
            }, "robots") : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: ogTitle
            }, "og:title"),
            ogDescription ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: ogDescription
            }, "og:description") : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: ogType
            }, "og:type"),
            ((ref10 = props.openGraph) === null || ref10 === void 0 ? void 0 : ref10.image) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: props.openGraph.image
                    }, "og:image"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:secure_url",
                        content: props.openGraph.image
                    }, "og:image:secure_url")
                ]
            }) : null,
            ogUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: ogUrl
            }, "og:url") : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: twCard
            }, "twitter:card"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: twTitle
            }, "twitter:title"),
            twDescription ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: twDescription
            }, "twitter:description") : null,
            ((ref11 = props.twitter) === null || ref11 === void 0 ? void 0 : ref11.image) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: props.twitter.image
            }, "twitter:image") : null,
            twUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:url",
                content: twUrl
            }, "twitter:url") : null,
            (ref12 = props.jsonLd) === null || ref12 === void 0 ? void 0 : ref12.map((block, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(block)
                    }
                }, "jsonld-".concat(idx))),
            props.children
        ]
    });
}


/***/ }),

/***/ 276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ about_us; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(6066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(1548);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(3873);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(6886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(5861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(9417);
// EXTERNAL MODULE: ./components/AppWrapperContainer.tsx
var AppWrapperContainer = __webpack_require__(4208);
;// CONCATENATED MODULE: ./public/assets/images/home/more/about-us/AboutUsBg.webp
/* harmony default export */ var AboutUsBg = ({"src":"/_next/static/media/AboutUsBg.0fdca80e.webp","height":1596,"width":4500,"blurDataURL":"data:image/webp;base64,UklGRjYAAABXRUJQVlA4ICoAAADQAQCdASoIAAMAAkA4JYwCdAEO/gPIAAD+/InigtTttT1WIKmd2HPUwAA=","blurWidth":8,"blurHeight":3});
// EXTERNAL MODULE: ./data/StaticList.ts + 67 modules
var StaticList = __webpack_require__(4485);
// EXTERNAL MODULE: ./public/assets/images/home/more/about-us/Ankit.webp
var Ankit = __webpack_require__(8455);
;// CONCATENATED MODULE: ./public/assets/images/home/more/about-us/gromoTeam.webp
/* harmony default export */ var gromoTeam = ({"src":"/_next/static/media/gromoTeam.67051d57.webp","height":1120,"width":2880,"blurDataURL":"data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACwAQCdASoIAAMAAkA4JZQAAudr6KaAAOJhRB7/dV5qed16PcC06nqX60T8AAAA","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/assets/images/home/more/about-us/openPositionBg.webp
/* harmony default export */ var openPositionBg = ({"src":"/_next/static/media/openPositionBg.5f37ce66.webp","height":1280,"width":2876,"blurDataURL":"data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACwAQCdASoIAAQAAkA4JaQAAp1NNeYAAP73nzazT55bGUuj3S6Q5NfU+x5WoOAA","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/AppFooter.tsx + 6 modules
var AppFooter = __webpack_require__(9705);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Seo.tsx
var Seo = __webpack_require__(2448);
;// CONCATENATED MODULE: ./pages/about-us/index.tsx
















function AboutUs() {
    const investorsIconsRef = (0,react.useRef)(null);
    const investorsImagesRef = (0,react.useRef)(null);
    const settings = {
        dots: true,
        infinite: false,
        autoplaySpeed: 4000,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: true,
        className: "teamsCard-dots"
    };
    const settingsInvestorsIcon = {
        infinite: false,
        speed: 2000,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        initialSlide: 0,
        rtl: false,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };
    const settingsInvestorImage = {
        infinite: false,
        speed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        initialSlide: 0,
        rtl: false,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };
    (0,react.useEffect)(()=>{
        var ref, ref1;
        (ref = investorsIconsRef.current) === null || ref === void 0 ? void 0 : ref.slickGoTo(0, true);
        (ref1 = investorsImagesRef.current) === null || ref1 === void 0 ? void 0 : ref1.slickGoTo(0, true);
        const tick = (ref, itemCount)=>{
            var ref1, ref2;
            const slider = ref.current;
            const inner = slider === null || slider === void 0 ? void 0 : slider.innerSlider;
            if (!inner) return;
            var ref3;
            const current = (ref3 = (ref1 = inner.state) === null || ref1 === void 0 ? void 0 : ref1.currentSlide) !== null && ref3 !== void 0 ? ref3 : 0;
            var ref4;
            const show = (ref4 = (ref2 = inner.props) === null || ref2 === void 0 ? void 0 : ref2.slidesToShow) !== null && ref4 !== void 0 ? ref4 : 1;
            const lastIndex = Math.max(0, itemCount - show);
            if (current >= lastIndex) {
                var ref5;
                (ref5 = ref.current) === null || ref5 === void 0 ? void 0 : ref5.slickGoTo(0, true);
            } else {
                var ref6;
                (ref6 = ref.current) === null || ref6 === void 0 ? void 0 : ref6.slickNext();
            }
        };
        const iconsInterval = window.setInterval(()=>{
            tick(investorsIconsRef, StaticList/* INVESTOR_ICONS.length */.iX.length);
        }, 4000);
        const imagesInterval = window.setInterval(()=>{
            tick(investorsImagesRef, StaticList/* INVESTORS_IMAGES.length */.EE.length);
        }, 4500);
        return ()=>{
            window.clearInterval(iconsInterval);
            window.clearInterval(imagesInterval);
        };
    }, []);
    const settingsRecord = {
        dots: true,
        infinite: false,
        autoplaySpeed: 4000,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* default */.Z, {
                title: "About GroMo | Founded by IIT Delhi Alumni | Y Combinator Backed | 60L+ Partners",
                description: "Learn about GroMo—India’s largest financial product distribution platform—our mission, team, and the story behind 60L+ partners earning by selling financial products.",
                keywords: "About GroMo, GroMo founders, GroMo mission, financial product distribution platform, fintech India",
                openGraph: {
                    title: "About GroMo | India’s Largest Financial Product Distribution Platform | 60L+ Partners",
                    description: "Become a partner and make a regular income by selling financial products. Brand yourself as a certified financial advisor and launch and grow your business.",
                    type: "website",
                    image: "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp",
                    url: "https://gromo.in/about-us"
                },
                twitter: {
                    title: "About GroMo | India’s Largest Financial Product Distribution Platform | 60L+ Partners",
                    description: "Become a partner and make a regular income by selling financial products. Brand yourself as a certified financial advisor and launch and grow your business.",
                    url: "https://gromo.in/about-us",
                    image: "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp"
                },
                jsonLd: [
                    {
                        "@context": "https://schema.org",
                        "@type": "AboutPage",
                        "@id": "https://gromo.in/about-us#aboutpage",
                        url: "https://gromo.in/about-us",
                        name: "About GroMo",
                        about: {
                            "@id": "https://gromo.in/#organization"
                        },
                        isPartOf: {
                            "@id": "https://gromo.in/#website"
                        }
                    }
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppWrapperContainer/* default */.Z, {
                nav: true,
                navBgColor: "#002561",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            sx: {
                                minHeight: {
                                    xs: "70vh",
                                    md: "80vh"
                                },
                                position: "relative"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    sx: {
                                        display: "flex",
                                        justifyContent: {
                                            xs: "center",
                                            md: "flex-end"
                                        },
                                        alignItems: "center",
                                        flexDirection: "column",
                                        minHeight: {
                                            xs: "40vh",
                                            md: "30vh"
                                        },
                                        zIndex: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                fontSize: {
                                                    xs: "16px",
                                                    md: "20px"
                                                },
                                                lineHeight: {
                                                    xs: "24px",
                                                    md: "32px"
                                                },
                                                fontWeight: "600",
                                                background: "linear-gradient(92.52deg, #08AC17 -8.14%, #4D71D0 81.48%)",
                                                webkitBackgroundClip: "text",
                                                webkitTextFillColor: "transparent",
                                                backgroundClip: "text",
                                                textFillColor: "transparent",
                                                border: "2px solid #E5E7EB",
                                                width: "fit-content",
                                                padding: "8px 16px",
                                                borderRadius: "100px",
                                                marginTop: {
                                                    xs: "36px",
                                                    md: "24px 0"
                                                }
                                            },
                                            children: "Our mission"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            component: "h1",
                                            sx: {
                                                fontSize: {
                                                    xs: "28px",
                                                    md: "40px"
                                                },
                                                lineHeight: {
                                                    xs: "36px",
                                                    md: "56px"
                                                },
                                                fontWeight: {
                                                    xs: "700",
                                                    md: "700"
                                                },
                                                color: "#0A0C0F",
                                                textAlign: "center",
                                                margin: {
                                                    xs: "auto 24px",
                                                    md: "0"
                                                }
                                            },
                                            children: "Create 60 Lakhs+ micro-entrepreneurs all over India"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                fontSize: {
                                                    xs: "16px",
                                                    md: "20px"
                                                },
                                                lineHeight: {
                                                    xs: "24px",
                                                    md: "32px"
                                                },
                                                fontWeight: {
                                                    xs: "500",
                                                    md: "600"
                                                },
                                                color: "#0A0C0F",
                                                textAlign: "center",
                                                margin: {
                                                    xs: "0 24px",
                                                    md: "0"
                                                }
                                            },
                                            children: "By giving them a platform to earn by selling financial products within their trusted network"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    sx: {
                                        width: "100%",
                                        height: {
                                            xs: "30vh",
                                            md: "60vh"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: AboutUsBg,
                                        alt: "GroMo mission banner illustration",
                                        style: {
                                            objectFit: "contain",
                                            width: "100%"
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            sx: {
                                padding: {
                                    xs: "",
                                    md: "80px 0 48px 0"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        textAlign: "center",
                                        fontSize: {
                                            xs: "18px",
                                            md: "20px"
                                        },
                                        lineHeight: {
                                            xs: "24px",
                                            md: "32px"
                                        },
                                        fontWeight: "500"
                                    },
                                    children: "Values we swear by"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    sx: {
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        margin: "12px auto 24px auto"
                                    },
                                    children: StaticList/* RECORD_LIST.map */.GO.map((item)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                fontSize: {
                                                    xs: "44px",
                                                    md: "64px"
                                                },
                                                lineHeight: {
                                                    xs: "36px",
                                                    md: "72px"
                                                },
                                                fontWeight: "700",
                                                margin: "0 8px",
                                                color: item.color
                                            },
                                            children: item.text
                                        }, item.title);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    sx: {
                                        margin: "36px auto",
                                        width: "80%",
                                        display: {
                                            xs: "block",
                                            md: "none"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                        ...settingsRecord,
                                        children: StaticList/* RECORD_LIST.map */.GO.map((item)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                sx: {
                                                    maxWidth: "450px",
                                                    height: {
                                                        xs: "",
                                                        md: "120px"
                                                    },
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                    flexDirection: {
                                                        xs: "column",
                                                        md: "row"
                                                    },
                                                    margin: {
                                                        xs: "",
                                                        md: "24px"
                                                    },
                                                    justifyContent: {
                                                        xs: "center",
                                                        md: "normal"
                                                    },
                                                    textAlign: {
                                                        xs: "center",
                                                        md: ""
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        sx: {
                                                            fontSize: {
                                                                xs: "40px",
                                                                md: "64px"
                                                            },
                                                            lineHeight: {
                                                                xs: "32px",
                                                                md: "72px"
                                                            },
                                                            fontWeight: "700",
                                                            height: "120px",
                                                            width: "120px",
                                                            display: "grid",
                                                            placeContent: "center",
                                                            borderRadius: "100px",
                                                            margin: "auto",
                                                            background: item.color,
                                                            color: "white"
                                                        },
                                                        children: item.text
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                        sx: {
                                                            padding: "8px 12px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                sx: {
                                                                    fontSize: "24px",
                                                                    lineHeight: "36px",
                                                                    fontWeight: "700"
                                                                },
                                                                children: item.title
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                sx: {
                                                                    fontSize: "18px",
                                                                    lineHeight: "24px",
                                                                    fontWeight: "400",
                                                                    color: "#6C717F"
                                                                },
                                                                children: item.content
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, item.color);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    sx: {
                                        display: {
                                            xs: "none",
                                            md: "flex"
                                        },
                                        justifyContent: "center",
                                        width: "80%",
                                        margin: "24px auto",
                                        padding: "24px",
                                        maxWidth: "1440px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            children: StaticList/* RECORD_LIST.filter */.GO.filter((item, i)=>i < 3).map((item)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                    sx: {
                                                        maxWidth: "450px",
                                                        height: "120px",
                                                        display: "flex",
                                                        alignItems: "flex-start",
                                                        margin: {
                                                            xs: "12px",
                                                            md: "24px"
                                                        }
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                            sx: {
                                                                fontSize: "32px",
                                                                lineHeight: "40px",
                                                                fontWeight: "700",
                                                                height: "120px",
                                                                minWidth: "120px",
                                                                display: "grid",
                                                                placeContent: "center",
                                                                borderRadius: "100px",
                                                                color: "white",
                                                                backgroundColor: item.color
                                                            },
                                                            children: item.text
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                            sx: {
                                                                padding: "8px 12px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    sx: {
                                                                        fontSize: "24px",
                                                                        lineHeight: "36px",
                                                                        fontWeight: "700"
                                                                    },
                                                                    children: item.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    sx: {
                                                                        fontSize: "18px",
                                                                        lineHeight: "24px",
                                                                        fontWeight: "400",
                                                                        color: "#6C717F"
                                                                    },
                                                                    children: item.content
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, item.title);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            children: StaticList/* RECORD_LIST.filter */.GO.filter((item, i)=>i >= 3).map((item)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                    sx: {
                                                        maxWidth: "450px",
                                                        height: "120px",
                                                        display: "flex",
                                                        alignItems: "flex-start",
                                                        margin: {
                                                            xs: "",
                                                            md: "24px"
                                                        }
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                            sx: {
                                                                fontSize: "32px",
                                                                lineHeight: "40px",
                                                                fontWeight: "700",
                                                                height: "120px",
                                                                minWidth: "120px",
                                                                display: "grid",
                                                                placeContent: "center",
                                                                borderRadius: "100px",
                                                                color: "white",
                                                                backgroundColor: item.color
                                                            },
                                                            children: item.text
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                            sx: {
                                                                padding: "8px 12px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    sx: {
                                                                        fontSize: "24px",
                                                                        lineHeight: "36px",
                                                                        fontWeight: "700"
                                                                    },
                                                                    children: item.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    sx: {
                                                                        fontSize: "18px",
                                                                        lineHeight: "24px",
                                                                        fontWeight: "400",
                                                                        color: "#6C717F"
                                                                    },
                                                                    children: item.content
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, item.title);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            sx: {
                                padding: {
                                    xs: "24px",
                                    md: "48px"
                                },
                                position: "relative",
                                margin: "24px auto",
                                maxWidth: "1440px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        textAlign: "center",
                                        fontSize: {
                                            xs: "24px",
                                            md: "40px"
                                        },
                                        lineHeight: {
                                            xs: "36px",
                                            md: "56px"
                                        },
                                        fontWeight: {
                                            xs: "700",
                                            md: "600"
                                        },
                                        margin: {
                                            xs: "",
                                            md: "8px 0"
                                        }
                                    },
                                    children: "Meet Our Founders"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    sx: {
                                        display: {
                                            xs: "none",
                                            md: "flex"
                                        },
                                        flexWrap: "wrap",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        margin: {
                                            xs: "24px auto",
                                            md: "36px auto"
                                        },
                                        width: "85%"
                                    },
                                    children: StaticList/* TEAM_CARDS.map */.JB.map((item, i)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                            sx: {
                                                width: {
                                                    xs: "100%",
                                                    md: "350px"
                                                },
                                                margin: "16px 8px",
                                                zIndex: 2,
                                                display: {
                                                    xs: i > 3 ? "none" : "block",
                                                    md: "block"
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                    sx: {
                                                        width: "100%",
                                                        position: "relative",
                                                        border: "1px solid #DEE7FF",
                                                        borderRadius: "12px"
                                                    },
                                                    id: "card",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: item.img || Ankit/* default */.Z,
                                                            alt: "AboutUsBg",
                                                            style: {
                                                                objectFit: "contain",
                                                                borderRadius: "12px"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                            id: "cardText",
                                                            sx: {
                                                                position: "absolute",
                                                                height: "100%",
                                                                width: "100%",
                                                                inset: 0
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    sx: {
                                                                        fontSize: "20px",
                                                                        fontWeight: "600",
                                                                        padding: "12px 12px 0 12px",
                                                                        color: "white",
                                                                        textAlign: "center"
                                                                    },
                                                                    children: item.hoverText
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    sx: {
                                                                        fontSize: "14px",
                                                                        fontWeight: "400",
                                                                        padding: "0 12px 12px 12px",
                                                                        color: "white",
                                                                        textAlign: "center"
                                                                    },
                                                                    children: item.hoverText2
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    sx: {
                                                        fontSize: {
                                                            xs: "24px",
                                                            md: "28px"
                                                        },
                                                        lineHeight: "36px",
                                                        fontWeight: "700",
                                                        color: "#393F50",
                                                        margin: {
                                                            xs: "4px 0",
                                                            md: "8px 0"
                                                        }
                                                    },
                                                    children: item.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: item.linkedIn,
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            width: "35",
                                                            height: "32",
                                                            viewBox: "0 0 35 36",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            style: {
                                                                transform: "scale(.8)"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M32.5 0.5H2.42188C1.09375 0.5 0 1.67188 0 3.07812V33C0 34.4062 1.09375 35.5 2.42188 35.5H32.5C33.8281 35.5 35 34.4062 35 33V3.07812C35 1.67188 33.8281 0.5 32.5 0.5ZM10.5469 30.5H5.39062V13.8594H10.5469V30.5ZM7.96875 11.5156C6.25 11.5156 4.92188 10.1875 4.92188 8.54688C4.92188 6.90625 6.25 5.5 7.96875 5.5C9.60938 5.5 10.9375 6.90625 10.9375 8.54688C10.9375 10.1875 9.60938 11.5156 7.96875 11.5156ZM30 30.5H24.7656V22.375C24.7656 20.5 24.7656 18 22.1094 18C19.375 18 18.9844 20.1094 18.9844 22.2969V30.5H13.8281V13.8594H18.75V16.125H18.8281C19.5312 14.7969 21.25 13.3906 23.75 13.3906C28.9844 13.3906 30 16.9062 30 21.3594V30.5Z",
                                                                fill: "#5377D7"
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        }, item.name);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    sx: {
                                        display: {
                                            xs: "block",
                                            md: "none"
                                        },
                                        flexWrap: "wrap",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        margin: {
                                            xs: "24px auto",
                                            md: "36px auto"
                                        },
                                        width: "85%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                        ...settings,
                                        children: StaticList/* TEAM_CARDS.map */.JB.map((item, i)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                sx: {
                                                    width: {
                                                        xs: "100%",
                                                        md: "30%"
                                                    },
                                                    zIndex: 2,
                                                    padding: "10px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                        sx: {
                                                            width: "100%",
                                                            position: "relative",
                                                            border: "1px solid #DEE7FF",
                                                            borderRadius: "12px"
                                                        },
                                                        id: "card",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: item.img || Ankit/* default */.Z,
                                                                alt: "AboutUsBg",
                                                                style: {
                                                                    objectFit: "contain",
                                                                    borderRadius: "12px"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                                id: "cardText",
                                                                sx: {
                                                                    position: "absolute",
                                                                    height: "100%",
                                                                    width: "100%",
                                                                    inset: 0
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        sx: {
                                                                            fontSize: "20px",
                                                                            fontWeight: "600",
                                                                            padding: "12px 12px 0 12px",
                                                                            color: "white",
                                                                            textAlign: "center"
                                                                        },
                                                                        children: item.hoverText
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        sx: {
                                                                            fontSize: "14px",
                                                                            fontWeight: "400",
                                                                            padding: "0 12px 12px 12px",
                                                                            color: "white",
                                                                            textAlign: "center"
                                                                        },
                                                                        children: item.hoverText2
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        sx: {
                                                            fontSize: {
                                                                xs: "24px",
                                                                md: "28px"
                                                            },
                                                            lineHeight: "36px",
                                                            fontWeight: "700",
                                                            color: "#393F50",
                                                            margin: {
                                                                xs: "4px 0",
                                                                md: "8px 0"
                                                            }
                                                        },
                                                        children: item.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: item.linkedIn,
                                                            target: "_blank",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                width: "35",
                                                                height: "32",
                                                                viewBox: "0 0 35 36",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                style: {
                                                                    transform: "scale(.8)"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M32.5 0.5H2.42188C1.09375 0.5 0 1.67188 0 3.07812V33C0 34.4062 1.09375 35.5 2.42188 35.5H32.5C33.8281 35.5 35 34.4062 35 33V3.07812C35 1.67188 33.8281 0.5 32.5 0.5ZM10.5469 30.5H5.39062V13.8594H10.5469V30.5ZM7.96875 11.5156C6.25 11.5156 4.92188 10.1875 4.92188 8.54688C4.92188 6.90625 6.25 5.5 7.96875 5.5C9.60938 5.5 10.9375 6.90625 10.9375 8.54688C10.9375 10.1875 9.60938 11.5156 7.96875 11.5156ZM30 30.5H24.7656V22.375C24.7656 20.5 24.7656 18 22.1094 18C19.375 18 18.9844 20.1094 18.9844 22.2969V30.5H13.8281V13.8594H18.75V16.125H18.8281C19.5312 14.7969 21.25 13.3906 23.75 13.3906C28.9844 13.3906 30 16.9062 30 21.3594V30.5Z",
                                                                    fill: "#5377D7"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, item.name);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    sx: {
                                        display: {
                                            xs: "none",
                                            md: "block"
                                        },
                                        position: "absolute",
                                        top: 0,
                                        right: 0,
                                        zIndex: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "100%",
                                        height: "800",
                                        viewBox: "0 0 475 800",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                opacity: "0.15",
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M400 800C620.914 800 800 620.914 800 400C800 179.086 620.914 0 400 0C179.086 0 0 179.086 0 400C0 620.914 179.086 800 400 800ZM399.999 644.444C264.996 644.444 155.555 535.003 155.555 400C155.555 264.997 264.996 155.555 399.999 155.555C535.002 155.555 644.444 264.997 644.444 400C644.444 535.003 535.002 644.444 399.999 644.444Z",
                                                fill: "url(#paint0_linear_31322_266948)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                    id: "paint0_linear_31322_266948",
                                                    x1: "377.604",
                                                    y1: "-7.37655e-08",
                                                    x2: "377.604",
                                                    y2: "641.146",
                                                    gradientUnits: "userSpaceOnUse",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            stopColor: "#3366E8",
                                                            stopOpacity: "0.6"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            offset: "1",
                                                            stopColor: "#3366E8",
                                                            stopOpacity: "0.01"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    sx: {
                                        display: {
                                            xs: "none",
                                            md: "block"
                                        },
                                        position: "absolute",
                                        left: 0,
                                        top: "20%",
                                        bottom: "50%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "100%",
                                        height: "800",
                                        viewBox: "0 0 400 800",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                opacity: "0.15",
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M-3.05176e-05 800C220.914 800 400 620.914 400 400C400 179.086 220.914 0 -3.05176e-05 0C-220.914 0 -400 179.086 -400 400C-400 620.914 -220.914 800 -3.05176e-05 800ZM-0.000854492 644.445C-135.004 644.445 -244.445 535.003 -244.445 400C-244.445 264.997 -135.004 155.556 -0.000854492 155.556C135.002 155.556 244.444 264.997 244.444 400C244.444 535.003 135.002 644.445 -0.000854492 644.445Z",
                                                fill: "url(#paint0_linear_31322_266951)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                    id: "paint0_linear_31322_266951",
                                                    x1: "-22.3958",
                                                    y1: "-7.37655e-08",
                                                    x2: "-22.3958",
                                                    y2: "641.146",
                                                    gradientUnits: "userSpaceOnUse",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            stopColor: "#3366E8",
                                                            stopOpacity: "0.01"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            offset: "1",
                                                            stopColor: "#3366E8",
                                                            stopOpacity: "0.6"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            sx: {
                                margin: {
                                    xs: "72px 0",
                                    md: "120px 0"
                                },
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: gromoTeam,
                                alt: "gromoTeam",
                                style: {
                                    objectFit: "contain",
                                    width: "100%"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            sx: {
                                padding: {
                                    xs: "",
                                    md: "24px"
                                },
                                maxWidth: "1440px",
                                margin: "auto"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        fontSize: {
                                            xs: "24px",
                                            md: "40px"
                                        },
                                        lineHeight: {
                                            xs: "36px",
                                            md: "56px"
                                        },
                                        fontWeight: {
                                            xs: "700",
                                            md: "600"
                                        },
                                        color: "#0A0C0F",
                                        textAlign: "center"
                                    },
                                    children: "Our investors"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    sx: {
                                        width: {
                                            xs: "85%",
                                            md: "70%"
                                        },
                                        margin: "24px auto"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                        ref: investorsIconsRef,
                                        ...settingsInvestorsIcon,
                                        children: StaticList/* INVESTOR_ICONS.map */.iX.map((item, i)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                sx: {
                                                    padding: "0 12px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: item.img,
                                                    alt: "investors",
                                                    style: {
                                                        objectFit: "contain",
                                                        borderRadius: "12px"
                                                    }
                                                })
                                            }, i);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    sx: {
                                        width: "80%",
                                        margin: "24px auto"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                        ref: investorsImagesRef,
                                        ...settingsInvestorImage,
                                        children: StaticList/* INVESTORS_IMAGES.map */.EE.map((item, i)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                sx: {
                                                    padding: "0 12px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: item.img,
                                                    alt: "investorImg",
                                                    style: {
                                                        objectFit: "contain",
                                                        borderRadius: "12px"
                                                    }
                                                })
                                            }, i);
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            sx: {
                                width: "100%",
                                height: {
                                    xs: "content-fit",
                                    md: "75vh"
                                },
                                backgroundImage: {
                                    xs: "",
                                    md: "linear-gradient(286.03deg, rgba(0, 0, 0, 0.1) 50.86%, rgba(0, 0, 0, 0) 88.16%), url(".concat(openPositionBg.src, ")")
                                },
                                backgroundPosition: {
                                    xs: "top",
                                    md: "center"
                                },
                                backgroundRepeat: "no-repeat",
                                backgroundSize: {
                                    xs: "contain",
                                    md: "cover"
                                },
                                position: "relative",
                                display: {
                                    xs: "flex",
                                    md: "grid"
                                },
                                flexDirection: "column",
                                gridTemplateColumns: "1fr 1fr",
                                placeContent: "center",
                                margin: "48px 0",
                                justifyContent: {
                                    xs: "center"
                                },
                                alignItems: {
                                    xs: "end"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    sx: {
                                        color: "white",
                                        width: {
                                            xs: "",
                                            md: "450px"
                                        },
                                        marginLeft: "16%",
                                        display: {
                                            xs: "none",
                                            md: "block"
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            sx: {
                                                fontSize: {
                                                    xs: "",
                                                    md: "40px"
                                                },
                                                lineHeight: {
                                                    xs: "",
                                                    md: "56px"
                                                },
                                                fontWeight: {
                                                    xs: "",
                                                    md: "400"
                                                },
                                                margin: {
                                                    xs: "",
                                                    md: "8px"
                                                },
                                                padding: "8px"
                                            },
                                            children: [
                                                "We love working here. ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "We think you will too."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            sx: {
                                                fontSize: {
                                                    xs: "",
                                                    md: "18px"
                                                },
                                                lineHeight: {
                                                    xs: "",
                                                    md: "24px"
                                                },
                                                fontWeight: {
                                                    xs: "",
                                                    md: "500"
                                                },
                                                margin: {
                                                    xs: "",
                                                    md: "8px"
                                                },
                                                padding: "8px"
                                            },
                                            children: [
                                                "We believe people can do remarkable work. They can push boundaries, solve problems and making something real. ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "If you have these amazing capabilities, we have a job for you."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "contained",
                                            sx: {
                                                backgroundColor: "#08AC17",
                                                color: "white",
                                                "&:hover": {
                                                    backgroundColor: "#08AC17"
                                                },
                                                padding: {
                                                    xs: "",
                                                    md: "12px 24px"
                                                },
                                                borderRadius: "4px",
                                                margin: {
                                                    xs: "",
                                                    md: "16px"
                                                }
                                            },
                                            onClick: ()=>window.location.href = "/career",
                                            children: "See open positions"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    sx: {
                                        display: {
                                            xs: "block",
                                            md: "none"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: openPositionBg,
                                        alt: "Open Position Background",
                                        style: {
                                            width: "100%",
                                            objectFit: "contain"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    sx: {
                                        width: {
                                            xs: "100%",
                                            md: "450px"
                                        },
                                        marginLeft: {
                                            xs: "0",
                                            md: "10%"
                                        },
                                        padding: "24px",
                                        display: {
                                            xs: "block",
                                            md: "none"
                                        },
                                        background: "white"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            sx: {
                                                fontSize: {
                                                    xs: "28px",
                                                    md: "40px"
                                                },
                                                lineHeight: {
                                                    xs: "36px",
                                                    md: "56px"
                                                },
                                                fontWeight: {
                                                    xs: "700",
                                                    md: "400"
                                                },
                                                margin: {
                                                    xs: "8px 0",
                                                    md: "16px"
                                                }
                                            },
                                            children: [
                                                "We love working here. ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "We think you will too."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            sx: {
                                                fontSize: "18px",
                                                lineHeight: "24px",
                                                fontWeight: {
                                                    xs: "400",
                                                    md: "500"
                                                },
                                                margin: {
                                                    xs: "8px 0",
                                                    md: "16px"
                                                }
                                            },
                                            children: [
                                                "We believe people can do remarkable work. They can push boundaries, solve problems and making something real. ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "If you have these amazing capabilities, we have a job for you."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "contained",
                                            sx: {
                                                backgroundColor: "#08AC17",
                                                color: "white",
                                                "&:hover": {
                                                    backgroundColor: "#08AC17"
                                                },
                                                padding: {
                                                    xs: "",
                                                    md: "12px 24px"
                                                },
                                                borderRadius: "4px",
                                                margin: {
                                                    xs: "",
                                                    md: "16px"
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/careers",
                                                children: "See open positions"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppFooter["default"], {})
        ]
    });
}
/* harmony default export */ var about_us = (AboutUs);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3581,6886,6499,5675,7538,5045,1033,4938,4485,9705,7486,9774,2888,179], function() { return __webpack_exec__(6565); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);